import { render, staticRenderFns } from "./alisms_list.vue?vue&type=template&id=2b1ac512&scoped=true"
import script from "./alisms_list.vue?vue&type=script&lang=js"
export * from "./alisms_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1ac512",
  null
  
)

export default component.exports